import React, { useState } from 'react'
import { tokens } from "../../../theme";
import {  MenuItem, SubMenu } from "react-pro-sidebar";
import { Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import FactoryIcon from '@mui/icons-material/Factory';
import EditIcon from '@mui/icons-material/Edit';
import AllInboxIcon from '@mui/icons-material/AllInbox';
import AppsIcon from '@mui/icons-material/Apps';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import HandymanIcon from '@mui/icons-material/Handyman';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import HomeRepairServiceOutlinedIcon from '@mui/icons-material/HomeRepairServiceOutlined';
import HailIcon from '@mui/icons-material/Hail';

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};


const Deposito = () => {
  const [selected, setSelected] = useState("Dashboard");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <>
                    <SubMenu
                      title="Amoxarifado"
                      icon={<FactoryIcon/>}
                      style={{ color: colors.grey[300] }}
                    ><SubMenu
                        title="Registros"
                        icon={<FactoryIcon/>}
                        style={{ color: colors.grey[300] }}
                      >
                        <Item
                          title="Productos"
                          to="/registros/productosamoxarifado"
                          icon={<HandymanIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <SubMenu
                        title="Editar"
                        icon={<EditIcon/>}
                        style={{ color: colors.grey[300] }}
                      >
                        <Item
                          title="Productos"
                          to="/registros/editarproductos"
                          icon={<HandymanIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                      </SubMenu>
                        <Item
                          title="Depositos"
                          to="/registros/depositosamoxarifado"
                          icon={<FactoryIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Categorias"
                          to="/registros/categoriasamoxarifado"
                          icon={<HomeRepairServiceIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Sub-Categorias"
                          to="/registros/subcategoriasamoxarifado"
                          icon={<HomeRepairServiceOutlinedIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Estante"
                          to="/registro/estante"
                          icon={<AllInboxIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Fila"
                          to="/registro/fila"
                          icon={<FormatListNumberedIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Columna"
                          to="/registro/columna"
                          icon={<AppsIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                      </SubMenu>
                      <SubMenu
                        title="Movimientos"
                        icon={<FactoryIcon/>}
                        style={{ color: colors.grey[300] }}
                      >
                        <Item
                          title="Salida Personal"
                          to="/registro/salidaProduct"
                          icon={<HailIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />

                      </SubMenu>

                        <SubMenu
                          title="Stock"
                          icon={<ReceiptOutlinedIcon />}
                          style={{ color: colors.grey[300] }}
                          >
                            <Item
                              title="Registro Stock"
                              to="/registros/stockDeposito"
                              icon={<ReceiptOutlinedIcon />}
                              selected={selected}
                              setSelected={setSelected}
                            />
                            <Item
                              title="Registro Devolucion"
                              to="/registros/devolucionDeposito"
                              icon={<ReceiptOutlinedIcon />}
                              selected={selected}
                              setSelected={setSelected}
                            />
                         </SubMenu>
                      
                      <SubMenu
                        title="Consultas"
                        icon={<ReceiptOutlinedIcon />}
                        style={{ color: colors.grey[300] }}
                      >
                        <Item
                          title="Productos"
                          to="/consultas/productosamoxarifado"
                          icon={<ReceiptOutlinedIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Stock"
                          to="/consultas/stockamoxarifado"
                          icon={<ReceiptOutlinedIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Prestamos"
                          to="/consultas/prestamoamoxarifado"
                          icon={<ReceiptOutlinedIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Historial"
                          to="/consultas/historialDeposito"
                          icon={<ReceiptOutlinedIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Stock Minimo"
                          to="/consultas/stockMinimo"
                          icon={<ReceiptOutlinedIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                      </SubMenu>
                    </SubMenu>
              </>
  )
}


export default Deposito
